module.exports = __webpack_public_path__ + "poster/suzanne-demands.jpg";